import { useContext } from 'react'
import AppContext from '../config/context/app'

export const useCustomDomain = () => {
  const { customDomain, setCustomDomainPreview } = useContext(AppContext)

  return { customDomain, setCustomDomainPreview }
}
